import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { BaseComponent } from '../../shared/base/base.component';

@Component({
  selector: 'app-tdlte-online',
  templateUrl: './tdlte-online.component.html',
  styleUrls: ['./tdlte-online.component.scss']
})
export class TdlteOnlineComponent extends BaseComponent implements OnInit {
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;

  constructor(
    public userService: UserService,
    public translator: TranslateService,
    public cookieService: CookieService,
    public zone: NgZone,
    public route: ActivatedRoute,
    public titleService: Title,
  ) {
    super(userService, translator, cookieService, titleService);
  }

  seed: any = { person_type: 'حقیقی' };
  lead: any = { name: '', family: '', tel: '', mobile: '', address: '', description: 'عدم امکان فروش TDLTE' };
  provider: string;
  tried: boolean;
  servicePrice: any;
  itemPrice: any;
  naturalAccount: any;
  legalAgentAccount: any;
  legalAccount: any;
  successMsg: string;
  errorMsg: string;
  captchaVerified: boolean = false;
  trying: boolean = false;
  activation_fee = 0;
  installation_cost = 0;
  default_installation_cost = 0;
  default_transport_cost = 0;
  wire_cost = 0;
  shipmentCost = 0;
  craVerified = true;
  dslCenterId: number;
  workflow_states = [
    'PAYMENT',
    'REGISTER_LEGAL_ACCOUNT',
    'REGISTER_LEGAL_AGENT_ACCOUNT',
    'REGISTER_NATURAL_ACCOUNT',
    'REGISTER_NATURAL_ACCOUNT',
    'CHOOSE_MODEM',
    'CHOOSE_SERVICE',
    'INQUIRY',
  ];
  current_state = 'INQUIRY';
  request_id: number;
  termsChecked: boolean = false;
  leaded: boolean = false;
  installLocation = { province: '', city: '', address: '', unit: '', postal_code: '' };
  private _requestInstaller: boolean = false;
  public get requestInstaller(): boolean {
    return this._requestInstaller;
  }
  public set requestInstaller(v: boolean) {
    this._requestInstaller = v;
    if (v || !this.itemPrice) {
      this.zone.run(() => {
        this.shipmentCost = 0;
      });
    } else {
      this.userService.getShipmentCost(this.installLocation, this.itemPrice).subscribe((result: any) => {
        this.zone.run(() => {
          this.shipmentCost = result.cost;
        });
      });
    }
  }

  private _requestInstall: boolean = false;
  public get requestInstall(): boolean {
    return this._requestInstall;
  }
  public set requestInstall(v: boolean) {
    this._requestInstall = v;
    this.requestInstaller = v;
    this.zone.run(() => {
      this.installation_cost = v ? this.default_installation_cost : 0;
    });
  }


  public get transportation_cost(): number {
    return this.requestInstaller ? this.default_transport_cost : 0;
  }


  public get total(): number {
    return this.getTotal();
  }

  public get vat(): number {
    return this.getVat();
  }

  public get payable(): number {
    return this.getPayable();
  }

  async ngOnInit() {
    this.addRecaptchaScript();
    if ((this.username || this.selectedAccount) && this.token && (!this.ownRole.includes('SALES') || this.selectedAccount)) {
      this.userService.getAccount(this.selectedAccount || this.username).subscribe((result: any) => {
        this.zone.run(() => {
          const account = result[0];
          if (account.person_type === 'N') {
            this.naturalAccount = account;
            this.seed.person_type = 'حقیقی';
          } else {
            this.legalAccount = account;
            this.legalAgentAccount = { username: account.agent_id };
            this.seed.person_type = 'حقوقی';
          }
        });
      });
    }

    const costs = await this.userService.apiCall('api/user/costs', { service_type: 'TDLTE' }).toPromise();
    this.activation_fee = +costs.find(c => c.id === 'COST_TDLTE_ACTIVATION_FEE').value || 0;
    this.default_installation_cost = +costs.find(c => c.id === 'COST_TDLTE_INSTALLATION_COST').value || 0;
    this.default_transport_cost = +costs.find(c => c.id === 'COST_TDLTE_TRANSPORT_COST').value || 0;
    // this.wire_cost = +costs.find(c => c.id === 'COST_TDLTE_WIRE_COST').value || 0;

  }

  getTotal(): number {
    return this.activation_fee +
      this.installation_cost +
      this.wire_cost +
      this.transportation_cost +
      this.shipmentCost +
      (this.servicePrice ? this.servicePrice.price : 0) +
      (this.itemPrice ? this.itemPrice.price : 0);
  }

  getVat(): number {
    return Math.round(this.total * 0.09);
  }

  getPayable(): number {
    return this.total + this.vat;
  }

  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    };

    (function (d, s, id, obj) {
      let js;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': '6LdMT-gUAAAAAD0SIi5t61Zb7ZKyQWKeJNb2-5bf',
      'hl': this.lang || 'fa',
      'expired-callback': () => {
        this.zone.run(() => {
          this.captchaVerified = false;
        });
      },
      'callback': (response) => {
        this.userService.confirmCaptcha(response).subscribe((result: any) => {
          this.zone.run(() => {
            this.captchaVerified = true;
          });
        }, error => {
          this.captchaVerified = true;
        });
      }
    });
  }

  onFormSubmit() {
    this.trying = false;
    this.tried = true;
    this.provider = 'MOBIN';
    this.successMsg = '';
    this.errorMsg = '';
    if (this.naturalAccount) {
      this.installLocation.province = this.naturalAccount.province;
      this.installLocation.city = this.naturalAccount.city;
      this.installLocation.address = this.naturalAccount.address;
      this.installLocation.unit = this.naturalAccount.unit;
      this.installLocation.postal_code = this.naturalAccount.postal_code;
    } else if (this.legalAccount) {
      this.installLocation.province = this.legalAccount.province;
      this.installLocation.city = this.legalAccount.city;
      this.installLocation.address = this.legalAccount.address;
      this.installLocation.unit = this.legalAccount.unit;
      this.installLocation.postal_code = this.legalAccount.postal_code;
    }
    this.current_state = 'CHOOSE_SERVICE';



    // this.userService.apiCall('api/user/inquiry_port', { username: `${this.seed.code}${this.seed.no}` }).subscribe((result: any) => {
    //   this.zone.run(() => {
    //     this.tried = true;
    //     this.trying = false;
    //     if (result.ok) {
    //       const jsonResult = result;
    //       if (!jsonResult.tci || jsonResult.tci.includes('موفقیت آمیز')) {
    //         this.provider = jsonResult.provider;
    //         this.installLocation.province = jsonResult.province;
    //         this.installLocation.city = jsonResult.city;
    //         if (this.naturalAccount &&
    //           this.naturalAccount.province === this.installLocation.province &&
    //           this.naturalAccount.city === this.installLocation.city) {
    //           this.installLocation.address = this.naturalAccount.address;
    //           this.installLocation.unit = this.naturalAccount.unit;
    //           this.installLocation.postal_code = this.naturalAccount.postal_code;
    //         } else if (this.legalAccount &&
    //           this.legalAccount.province === this.installLocation.province &&
    //           this.legalAccount.city === this.installLocation.city) {
    //           this.installLocation.address = this.legalAccount.address;
    //           this.installLocation.unit = this.legalAccount.unit;
    //           this.installLocation.postal_code = this.legalAccount.postal_code;
    //         }
    //         if (!this.dslCenterId) {
    //           this.dslCenterId = jsonResult.dsl_center_id;
    //         }
    //         // this.userService.apiCall('api/tdlte_request/create',
    //         //   {
    //         //     tel: `${this.seed.code}${this.seed.no}`,
    //         //     account_id: this.naturalAccount ? this.naturalAccount.username :
    //         // this.legalAccount ? this.legalAccount.username : undefined,
    //         //     vendor: this.provider
    //         //   }).subscribe((result2: any) => {
    //         //     this.request_id = result2.insertId;
    //         //   }, error => {
    //         //     console.error(error);
    //         //   });
    //         this.successMsg = 'TDLTE_INQUIRY_OK';
    //         this.current_state = 'CHOOSE_SERVICE';
    //       } else {
    //         this.tried = false;
    //         this.errorMsg = jsonResult.tci;
    //       }
    //     } else {
    //       this.errorMsg = 'TDLTE_INQUIRY_NOK_' + result.status;
    //       this.successMsg = 'TDLTE_INQUIRY_NOK_LEAD';
    //       // this.userService.apiCall('api/tdlte_request/create',
    //       //   {
    //       //     tel: `${this.seed.code}${this.seed.no}`,
    //       //     account_id: this.naturalAccount.username || this.legalAccount.username,
    //       //     last_error: this.errorMsg
    //       //   }).subscribe((result2: any) => {
    //       //     this.request_id = result2.insertId;
    //       //   }, error => {
    //       //     console.error(error);
    //       //   });
    //     }
    //   });
    // }, error => {
    //   this.zone.run(() => {
    //     this.tried = true;
    //     this.trying = false;
    //     console.error(error);
    //     this.errorMsg = 'TDLTE_INQUIRY_NOK_' + error.status;
    //     this.successMsg = 'TDLTE_INQUIRY_NOK_LEAD';
    //     // this.userService.apiCall('api/tdlte_request/create',
    //     //   {
    //     //     tel: `${this.seed.code}${this.seed.no}`,
    //     //     account_id: this.naturalAccount.username || this.legalAccount.username,
    //     //     last_error: this.errorMsg
    //     //   }).subscribe((result2: any) => {
    //     //     this.request_id = result2.insertId;
    //     //   }, error2 => {
    //     //     console.error(error2);
    //     //   });
    //   });
    // });

  }

  onLeadFormSubmit() {
    this.userService.apiCall('api/issue/lead', this.lead).subscribe((result: any) => {
      this.zone.run(() => {
        this.leaded = true;
        this.errorMsg = undefined;
        this.successMsg = 'TDLTE_INQUIRY_NOK_LEAD_OK';
      });
    }, error => {
      console.error(error);
    });
  }

  serviceChoosed(event) {
    this.servicePrice = event;
    this.successMsg = 'TDLTE_SERVICE_CHOOSED';
    this.current_state = 'CHOOSE_MODEM';
    // this.userService.apiCall('api/tdlte_request/update', { id: this.request_id, service_price_id: this.servicePrice.id });
  }

  itemChoosed(event) {
    this.itemPrice = event;
    this.successMsg = (this.naturalAccount || this.legalAccount) ? 'TDLTE_READY_FOR_PAYMENT' : 'TDLTE_MODEM_CHOOSED';
    this.current_state = this.seed.person_type === 'حقیقی' ? 'REGISTER_NATURAL_ACCOUNT' : 'REGISTER_LEGAL_AGENT_ACCOUNT';
    // this.userService.apiCall('api/tdlte_request/update', { id: this.request_id, item_price_id: this.itemPrice.id });
    if (this.installLocation.province && this.installLocation.city) {
      this.userService.getShipmentCost(this.installLocation, this.itemPrice).subscribe((result: any) => {
        this.shipmentCost = result.cost;
      });
    }
  }

  naturalAccountSaved(event) {
    this.naturalAccount = event;
    this.naturalAccount.username = this.naturalAccount.username || this.naturalAccount.email;
    if (this.naturalAccount) {
      this.installLocation.province = this.naturalAccount.province;
      this.installLocation.city = this.naturalAccount.city;
      this.installLocation.address = this.naturalAccount.address;
      this.installLocation.unit = this.naturalAccount.unit;
      this.installLocation.postal_code = this.naturalAccount.postal_code;
    }
    this.userService.getShipmentCost(this.installLocation, this.itemPrice).subscribe((result: any) => {
      this.shipmentCost = result.cost;
    });
    this.successMsg = 'TDLTE_READY_FOR_PAYMENT';
    this.current_state = 'PAYMENT';
  }

  legalAgentAccountSaved(event) {
    this.legalAgentAccount = event;
    this.legalAgentAccount.username = this.legalAgentAccount.username || this.legalAgentAccount.email;
    this.current_state = 'REGISTER_LEGAL_ACCOUNT';
    this.successMsg = 'TDLTE_AGENT_SAVED';
  }

  legalAccountSaved(event) {
    this.legalAccount = event;
    this.legalAccount.username = this.legalAccount.username || this.legalAccount.email;
    if (this.legalAccount) {
      this.installLocation.province = this.legalAccount.province;
      this.installLocation.city = this.legalAccount.city;
      this.installLocation.address = this.legalAccount.address;
      this.installLocation.unit = this.legalAccount.unit;
      this.installLocation.postal_code = this.legalAccount.postal_code;
    }
    this.userService.getShipmentCost(this.installLocation, this.itemPrice).subscribe((result: any) => {
      this.shipmentCost = result.cost;
    });
    this.successMsg = 'TDLTE_READY_FOR_PAYMENT';
    this.current_state = 'PAYMENT';
  }

  private userSave(event: any) {
    const user = {
      username: `${this.seed.code}${this.seed.no}`,
      account_id: event.email,
      created_by: event.email,
      service_type: 'TDLTE',
      vendor: this.provider
    };
    this.userService.apiCall('api/user/create_tdlte', user).subscribe((result: any) => {
      this.errorMsg = '';
      this.successMsg = 'TDLTE_READY_FOR_PAYMENT';
      this.current_state = 'PAYMENT';
    }, error => {
      this.successMsg = '';
      this.errorMsg = error.message || error;
    });
  }

  pay() {
    const account = this.naturalAccount || this.legalAccount;
    this.userService.createInvoiceAndPay(account,
      'AUTO',
      'TDLTE',
      this.provider,
      this.servicePrice,
      this.itemPrice,
      this.activation_fee,
      this.installation_cost,
      this.wire_cost,
      this.transportation_cost,
      this.shipmentCost,
      this.requestInstaller,
      this.installLocation,
      this.dslCenterId).subscribe((result: any) => {
        const invoice_id = result[0] ? result[0].id : undefined;
        // this.userService.apiCall('api/tdlte_request/update', { id: this.request_id, invoice_id: invoice_id });
        window.location.replace(`https://my.petiak.com/#/payall/${account.username || account.email}`);
      }, error => {
        console.error(error);
        this.errorMsg = error.message || error;
      });
  }

  return() {
    this.zone.run(() => {
      switch (this.current_state) {
        case 'INQUIRY':
        case 'CHOOSE_SERVICE':
          this.seed = { code: '', no: '', person_type: 'حقیقی' };
          this.current_state = 'INQUIRY';
          this.provider = undefined;
          this.tried = false;
          this.errorMsg = undefined;
          this.successMsg = undefined;
          break;
        case 'CHOOSE_MODEM':
          this.servicePrice = undefined;
          this.current_state = 'CHOOSE_SERVICE';
          this.successMsg = 'TDLTE_INQUIRY_OK';
          break;
        case 'REGISTER_NATURAL_ACCOUNT':
        case 'REGISTER_LEGAL_AGENT_ACCOUNT':
          this.itemPrice = undefined;
          this.current_state = 'CHOOSE_MODEM';
          this.successMsg = (this.naturalAccount || this.legalAccount) ? 'TDLTE_READY_FOR_PAYMENT' : 'TDLTE_SERVICE_CHOOSED';
          break;
        case 'REGISTER_LEGAL_ACCOUNT':
          this.legalAgentAccount = undefined;
          this.current_state = 'REGISTER_LEGAL_AGENT_ACCOUNT';
          this.successMsg = 'TDLTE_AGENT_SAVED';
          break;
        case 'PAYMENT':
          this.legalAccount = undefined;
          this.naturalAccount = undefined;
          this.current_state = this.seed.person_type === 'حقیقی' ? 'REGISTER_NATURAL_ACCOUNT' : 'REGISTER_LEGAL_ACCOUNT';
          this.successMsg = 'TDLTE_MODEM_CHOOSED';
          break;
        default:
          break;
      }
    });
  }

  home() {
    if (this.token) {
      window.location.replace(`https://my.petiak.com`);
    } else {
      window.location.replace(`https://petiak.com`);

    }
  }

  togglePersonType() {
    if (this.seed.person_type === 'حقیقی') {
      this.seed.person_type = 'حقوقی';
    } else {
      this.seed.person_type = 'حقیقی';
    }
  }

}
